/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const StorefrontScanResponseDTOStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Suspended: 'SUSPENDED',
    Exported: 'EXPORTED',
    Unavaliable: 'UNAVALIABLE',
    WaitingResults: 'WAITING_RESULTS'
};
/**
 * @export
 */
export const StorefrontScanResponseDTOTagEnum = {
    Control: 'CONTROL',
    Closed: 'CLOSED',
    Forbidden: 'FORBIDDEN'
};
/**
 * @export
 */
export const StorefrontScanResponseDTOTypeEnum = {
    Store: 'STORE',
    Category: 'CATEGORY'
};
/**
 * @export
 */
export const StorefrontScanResponseDTOLocationEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the StorefrontScanResponseDTO interface.
 */
export function instanceOfStorefrontScanResponseDTO(value) {
    return true;
}
export function StorefrontScanResponseDTOFromJSON(json) {
    return StorefrontScanResponseDTOFromJSONTyped(json, false);
}
export function StorefrontScanResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'url': json['url'] == null ? undefined : json['url'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'status': json['status'] == null ? undefined : json['status'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'type': json['type'] == null ? undefined : json['type'],
        'shopName': json['shopName'] == null ? undefined : json['shopName'],
        'location': json['location'] == null ? undefined : json['location'],
        'failedReason': json['failedReason'] == null ? undefined : json['failedReason'],
        'completedCategoryIds': json['completedCategoryIds'] == null ? undefined : json['completedCategoryIds'],
        'mainCategoryNames': json['mainCategoryNames'] == null ? undefined : json['mainCategoryNames'],
        'unavailableTryCount': json['unavailableTryCount'] == null ? undefined : json['unavailableTryCount'],
        'asins': json['asins'] == null ? undefined : json['asins'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
    };
}
export function StorefrontScanResponseDTOToJSON(json) {
    return StorefrontScanResponseDTOToJSONTyped(json, false);
}
export function StorefrontScanResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'url': value['url'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'status': value['status'],
        'tag': value['tag'],
        'type': value['type'],
        'shopName': value['shopName'],
        'location': value['location'],
        'failedReason': value['failedReason'],
        'completedCategoryIds': value['completedCategoryIds'],
        'mainCategoryNames': value['mainCategoryNames'],
        'unavailableTryCount': value['unavailableTryCount'],
        'asins': value['asins'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
    };
}
